<template>
  <van-tab :title="title">
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <record-panel
        class="bgwhite"
        v-for="(item, index) in list"
        :key="index"
        :record="item"
        :has-footer="true"
        :has-toolbar="false"
      />
    </van-list>
  </van-tab>
</template>

<script>
import { mapGetters } from 'vuex'
import { Icon, Tab, List } from 'vant'
import RecordPanel from '@/views/record/components/RecordPanel'
import { userRecordList } from '@/api/record'

export default {
  name: 'RecordTab',
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [List.name]: List,
    RecordPanel
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    review_status: {
      type: Number,
      default: undefined
    }
  },
  data () {
    return {
      keyword: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        user: '',
        review_status: '',
        page: 0,
        size: 8
      }
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
    this.cycleId = this.$route.params.cycle_id || ''
    this.listQuery.user = this.userprofile.uuid
    this.listQuery.review_status = this.review_status
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await userRecordList(this.listQuery)
      this.loading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
</style>
